<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 9L11.6464 15.6464C11.8417 15.8417 12.1583 15.8417 12.3536 15.6464L19 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGArrowDown',
};
</script>

<style scoped>

</style>